import { render } from "./PolicyIntroComp.vue?vue&type=template&id=43f5f4c8&scoped=true"
import script from "./PolicyIntroComp.vue?vue&type=script&lang=js"
export * from "./PolicyIntroComp.vue?vue&type=script&lang=js"

import "./PolicyIntroComp.vue?vue&type=style&index=0&id=43f5f4c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f5f4c8"]])

export default __exports__